module.exports = __webpack_public_path__ + "static/media/Montserrat-Medium.b3ba703c.ttf";